import { Tab, Tabs as TabsComp } from "@mui/material";
import TabsStyles from "./Tabs.module.scss";
import Typography from "../Typography/Typography";

const Tabs = ({ value, handleTabClick, tabs, key, tabsWidth = "32%" }: any) => {
  return (
    <div className={TabsStyles.dashboardSelector}>
      <TabsComp
        value={value}
        onChange={handleTabClick}
        variant="fullWidth"
        TabIndicatorProps={{
          style: {
            display: "none",
          },
        }}
        sx={{
          "& .MuiTabs-flexContainer": {
            gap: "8px",
          },
          minHeight: "unset",
          "& .MuiTabs-scroller": {
            // overflow: 'visible !important' // Allow overflow
          },
          background: "transparent",
          width: tabsWidth,
        }}
      >
        {tabs?.map((tab: any, index: number) => {
          const isActive = value === index;
          return (
            <Tab
              key={`${key}_${tab?.text}`}
              label={
                <Typography
                  fontSize={12}
                  style={{
                    fontWeight: "400",
                    whiteSpace: "nowrap",
                  }}
                >
                  {tab?.text}
                </Typography>
              }
              disabled={tab?.disabled}
              sx={{
                minHeight: "unset",
                padding: "13px 40px",
                borderRadius: "4px",
                minWidth: "unset",
                textTransform: "none",
                backgroundColor: "#fff",
                ...(!tab?.disabled && {
                  "&:hover": {
                    backgroundColor: "#f5f8ff",
                    opacity: 1,
                  },
                }),
                ...(isActive && {
                  borderBottom: "2px solid #4A84EF",
                }),
              }}
              style={
                isActive
                  ? {
                      background: "white",
                      color: "#4A84EF",
                    }
                  : {
                      background: "white",
                      color: "#6A6A6A",
                    }
              }
            />
          );
        })}
      </TabsComp>
    </div>
  );
};

export default Tabs;
